export const messages = {
  en: {
    nav: {
      home: 'Home',
      menu: 'Menu',
      myOrder: 'My Order',
      allergens: 'Allergens',
      categories: 'Categories',
    },
    menu: {
      categories: 'Categories',
      products: 'products',
      product: 'product',
    },
    order: {
      noOrderFound: 'No order found',
      title: 'My Order',
      order: 'Order',
      round: 'Round',
      table: 'Table',
      totalRound: 'Total Round',
      totalPrice: 'Total Price',
      paymentStatus: 'Payment Status',
      canOrder: 'Can Order',
      paid: 'PAID',
      unpaid: 'UNPAID',
      item: 'Item',
      qty: 'Qty',
      total: 'Total',
    },
    cart: {
      add: 'ADD',
      confirmTable: 'Please confirm your table!',
      confirm: 'Confirm',
      back: 'Back to menu',
    },
    availability: {
      unavailable: 'Unavailable',
      cartBlocked: 'Some items in your cart are not available right now. Remove them to place your order.',
      removeUnavailable: 'Remove unavailable items',
      remove: 'Remove',
    },
  },
  nl: {
    nav: {
      home: 'Home',
      menu: 'Menu',
      myOrder: 'Mijn Order',
      allergens: 'Allergenen',
      categories: 'Categorieën',
    },
    menu: {
      categories: 'Categorieën',
      products: 'producten',
      product: 'product',
    },
    order: {
      noOrderFound: 'Geen bestelling gevonden',
      title: 'Mijn Bestelling',
      order: 'Bestelling',
      round: 'Ronde',
      table: 'Tafel',
      totalRound: 'Totaal Rondes',
      totalPrice: 'Totaalbedrag',
      paymentStatus: 'Betaalstatus',
      canOrder: 'Kan Bestellen',
      paid: 'BETAALD',
      unpaid: 'ONBETAALD',
      item: 'Artikel',
      qty: 'Aantal',
      total: 'Totaal',
    },
    cart: {
      add: 'TOEVOEGEN',
      confirmTable: 'Bevestig eerst je tafel!',
      confirm: 'Bevestigen',
      back: 'Terug naar menu',
    },
    availability: {
      unavailable: 'Niet beschikbaar',
      cartBlocked: 'Sommige producten in je winkelwagen zijn nu niet beschikbaar. Verwijder ze om je bestelling te plaatsen.',
      removeUnavailable: 'Niet beschikbare producten verwijderen',
      remove: 'Verwijderen',
    },
  },
  // Translated from nl, the base locale POSHUB resolves against -- not from en.
  // `order.totalRound` labels order_rounds.length (MyOrder.vue:29), so it reads
  // as a count of rounds, not a monetary total.
  fr: {
    nav: {
      home: 'Accueil',
      menu: 'Menu',
      myOrder: 'Ma commande',
      allergens: 'Allergènes',
      categories: 'Catégories',
    },
    menu: {
      categories: 'Catégories',
      products: 'produits',
      product: 'produit',
    },
    order: {
      noOrderFound: 'Aucune commande trouvée',
      title: 'Ma commande',
      order: 'Commande',
      round: 'Tour',
      table: 'Table',
      totalRound: 'Nombre de tours',
      totalPrice: 'Montant total',
      paymentStatus: 'Statut du paiement',
      canOrder: 'Peut commander',
      paid: 'PAYÉ',
      unpaid: 'NON PAYÉ',
      item: 'Article',
      qty: 'Qté',
      total: 'Total',
    },
    cart: {
      add: 'AJOUTER',
      // Double-quoted for the apostrophe: the lint rule is single quotes with
      // avoidEscape, which prefers this over an escaped \'.
      confirmTable: "Veuillez d'abord confirmer votre table !",
      confirm: 'Confirmer',
      back: 'Retour au menu',
    },
    availability: {
      unavailable: 'Indisponible',
      cartBlocked: 'Certains articles de votre panier ne sont pas disponibles pour le moment. Retirez-les pour passer votre commande.',
      removeUnavailable: 'Retirer les articles indisponibles',
      remove: 'Retirer',
    },
  },
  es: {
    nav: {
      home: 'Inicio',
      menu: 'Menú',
      myOrder: 'Mi pedido',
      allergens: 'Alérgenos',
      categories: 'Categorías',
    },
    menu: {
      categories: 'Categorías',
      products: 'productos',
      product: 'producto',
    },
    order: {
      noOrderFound: 'No se ha encontrado ningún pedido',
      title: 'Mi pedido',
      order: 'Pedido',
      round: 'Ronda',
      table: 'Mesa',
      totalRound: 'Número de rondas',
      totalPrice: 'Importe total',
      paymentStatus: 'Estado del pago',
      canOrder: 'Puede pedir',
      paid: 'PAGADO',
      unpaid: 'NO PAGADO',
      item: 'Artículo',
      qty: 'Cant.',
      total: 'Total',
    },
    cart: {
      add: 'AÑADIR',
      confirmTable: '¡Confirma primero tu mesa!',
      confirm: 'Confirmar',
      back: 'Volver al menú',
    },
    availability: {
      unavailable: 'No disponible',
      cartBlocked: 'Algunos artículos de tu carrito no están disponibles en este momento. Elimínalos para hacer tu pedido.',
      removeUnavailable: 'Eliminar artículos no disponibles',
      remove: 'Eliminar',
    },
  },
};

import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'nl',
  fallbackLocale: 'en',
  messages,
});

export default i18n;
